<template>
  <!-- 企業検診案件詳細 -->
  <div id="KenshinRequestSearchDetail">
    <div id="container">
      <div class="labelTitle lable">企業検診 案件確認詳細</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr><th>受付番号</th><td>{{data.receiptNumber}}</td></tr>
            <tr><th>受付日</th><td>{{data.requestDate}}</td></tr>
            <tr><th>検査種類</th><td>{{getChoiceName(data.inspectionKind,inspectionKindList)}}<span v-if="data.demo" class="demo"/></td></tr>
            <tr><th>ステータス</th>
                <td>
                  <span :class="getTagClass(data.status)"> {{getStatusName(data.status)}} </span>
                  <template v-if="data.status==16">
                    <b-icon  style="margin-top:7px; width:20px;" icon="arrow-right-bold-outline" />
                    <b-button style="margin-left:5px; width:150px;" class="is-primary" v-on:click="confirmReExamination">再検査を実施する</b-button>
                    <b-button style="margin-left:5px; width:150px;" class="is-primary" @click="cancelReasonInputModalActive=true">検査をキャンセル</b-button>
                  </template>
                </td>
            </tr>
            <tr><th>機種</th><td>{{getChoiceName(data.model,kenshinDeviceList)}}</td></tr>
            <tr><th>シリアル</th><td>{{data.serial}}
              <b-button v-if="data.serial && data.status==3" style="margin-left:10px; width:150px; height:27px;" v-on:click="isChangeDeviceModalActive = true">予約機器変更</b-button>
            </td></tr>
            <tr><th>依頼元</th><td>{{data.client}}<span v-if="data.proxyFlag" class="agent"/></td></tr>
            <tr><th>企業名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.companyName}} {{data.enterpriseName}}</td></tr>
            <tr><th>発送先</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deviceDeliveryAddress}}</td></tr>
            <tr><th>名前</th><td>{{data.name}}</td></tr>
            <tr><th>性別</th><td>{{data.gender}}</td></tr>
            <tr><th>生年月日</th><td>{{data.birthday}}</td></tr>
            <tr><th>検査ID</th><td>{{data.examinationId}}</td></tr>
            <tr><th>AHI/ODI</th><td>{{data.ahiOdi}}</td></tr>
            <tr><th>出荷日</th><td>{{data.shippingDate}}</td></tr>
            <tr><th>機器返却日</th><td>{{data.returnDate}}</td></tr>
            <tr><th>判定依頼日</th><td>{{data.JudgmentRequestDate}}</td></tr>
            <tr><th>判定医</th><td>{{data.judgementName}}</td></tr>
            <tr><th>判定日</th><td>{{data.judgmentDate}}</td></tr>
            <tr><th>レポート発送日</th><td>{{data.reportShippingDate}}</td></tr>
            <tr><th>完了日</th><td>{{data.completionDate}}</td></tr>
          </table>
          <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
            <reasonInputModal  v-on:setReason="cancel" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
          </b-modal>
          <b-modal :active.sync="isChangeDeviceModalActive" has-modal-card>
            <changeDeviceModal v-bind:oldSerialNumber="data.serial" v-bind:model="data.model" v-bind:choicesType="choicesType.kenshinDevice" v-bind:receptionNo="data.receiptNumber" v-bind:type="'kenshin'" v-on:save="setNewSerial"></changeDeviceModal>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { choicesType, reExaminationConfirmTemplate } from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import ChangeDeviceModal from "@/components/mock/philips/common/ChangeDeviceModal";

export default {
  name: "KenshinRequestSearchDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "KenshinRequestSearch",
        params: { searchConditions: this.searchParams },
      });
    },
    getStatusName: function(code) {
      var target = this.statusList.find(val => val.code && val.code.includes(code))
      if(target){
        return target.name
      }
      return ""
    },
    getChoiceName: function(val,list) {
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    // 再検査実施前の確認ダイアログ表示
    confirmReExamination() {
      this.$dialog.confirm({
        title: "　",
        message: reExaminationConfirmTemplate.message,
        cancelText: reExaminationConfirmTemplate.cancelText,
        confirmText: reExaminationConfirmTemplate.confirmText,
        onConfirm: () => {
          this.reExamination();
        },
      });
    },
    reExamination: function() {
      // 再検査を実施する
      var excuteApi = this.setKenshinRequestInspectionAgainPOST;
      var successCallBack = this.setKenshinRequestInspectionAgainPOSTSuccess;
      var errorCallBack = this.setKenshinRequestInspectionAgainPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinRequestInspectionAgainPOST: function(client) {
      var shortestShippingDateList = this.getShortestShippingDate()
      return client.apis.internalKenshin.setKenshinRequestInspectionAgainPOST({
        body:{
          receiptNumber:this.data.receiptNumber,
          shortestShippingDateList:shortestShippingDateList,
          version:this.data.version
        }
      });
    },
    setKenshinRequestInspectionAgainPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setKenshinRequestInspectionAgainPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cancel: function(cancelReason) {
      // 検査をキャンセル
      this.reason = cancelReason
      var excuteApi = this.setKenshinRequestInspectionCancelPOST;
      var successCallBack = this.setKenshinRequestInspectionCancelPOSTSuccess;
      var errorCallBack = this.setKenshinRequestInspectionCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinRequestInspectionCancelPOST: function(client) {
      return client.apis.internalKenshin.setKenshinRequestInspectionCancelPOST({
        body:{
          receiptNumber:this.data.receiptNumber,
          reason:this.reason,
          version:this.data.version
        }
      });
    },
    setKenshinRequestInspectionCancelPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setKenshinRequestInspectionCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    setNewSerial: function(newSerial) {
      this.data.serial = newSerial
    }
  },
  data() {
    var statusList =[
      {name:"未受付", code:"[1]"}
     ,{name:"企業検診G受付済", code:"[11]"}
     ,{name:"川越受付済", code:"[2]"}
     ,{name:"出荷準備中", code:"[3]"}
     ,{name:"出荷済み", code:"[4]"}
     ,{name:"機器受領済み", code:"[5]"}
     ,{name:"再検査調整中", code:"[16]"}
     ,{name:"データ抽出済", code:"[100]"}
     ,{name:"判定依頼中", code:"[12]"}
     ,{name:"判定結果作成中", code:"[9]"}
     ,{name:"完了", code:"[13,14,15,18]"}
     ,{name:"キャンセル", code:"[17]"}
    ]
    var inspectionKindList = this.getChoiceList(choicesType.kenshinKind, false);
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    var item = this.$route.params["item"];
    var searchParams = this.$route.params["searchConditions"];
    return {
      searchParams,
      statusList,
      inspectionKindList,
      kenshinDeviceList,
      data: item,
      cancelReasonInputModalActive:false,
      reason:"",
      isChangeDeviceModalActive:false,
      choicesType
    };
  },
  filters: {},
  components: {
    reasonInputModal:reasonInputModal,
    changeDeviceModal:ChangeDeviceModal
  }
};
</script>
<style lang="scss" scoped>
.tag {
  width: 150px !important;
  height: 36px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinRequestSearchDetail.vue